import { Theme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';

export const orderDetailsCardStyle = makeStyles()(({ palette, spacing, shadows, breakpoints }: Theme) => ({
  root: {
    margin: spacing(0, 2, 4, 2),
    [breakpoints.up('md')]: {
      margin: spacing(0, 4, 4, 4),
    },
  },
  card: {
    padding: spacing(2),
    backgroundColor: palette.common.white,
    borderRadius: spacing(1),
    boxShadow: shadows[1],
  },
}));
